"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "mt-8"
  }, [_c("div", {
    staticClass: "btn-field-add"
  }, [_c("h4", [_vm._v("Produtos")]), _vm._v(" "), _c("b-button", {
    staticClass: "btn",
    on: {
      click: _vm.addProduct
    }
  }, [_vm._v("\n      Adicionar produto +\n    ")])], 1), _vm._v(" "), _vm._l(_vm.products, function (product) {
    var _product$productData;
    return _c("b-field", {
      key: product._id,
      attrs: {
        grouped: ""
      }
    }, [_c("b-field", {
      staticClass: "mt-8",
      attrs: {
        label: "Produto ".concat(product._id)
      }
    }, [_c("div", [_c("b-field", {
      attrs: {
        expanded: "",
        grouped: ""
      }
    }, [_c("app-select", {
      attrs: {
        value: (_product$productData = product.productData) === null || _product$productData === void 0 ? void 0 : _product$productData.id,
        label: "Produto",
        placeholder: "Selecione o produto",
        items: _vm.listProducts,
        option: "id",
        "name-item": "name",
        expanded: ""
      },
      on: {
        input: function input($event) {
          return _vm.selectProduct(product._id, $event);
        }
      }
    }), _vm._v(" "), _c("b-field", {
      attrs: {
        label: "Peso por Caixas",
        expanded: ""
      }
    }, [_c("money", _vm._b({
      staticClass: "input",
      attrs: {
        value: _vm.formatNumber(product.kg),
        placeholder: "Informe o peso por caixa",
        type: "text",
        id: "uname",
        expanded: ""
      },
      on: {
        input: function input($event) {
          return _vm.changeProductInput("kg", product._id, $event);
        }
      }
    }, "money", _vm.money, false))], 1), _vm._v(" "), _c("b-field", {
      attrs: {
        label: "Quantidade de Caixas",
        expanded: ""
      }
    }, [_c("money", _vm._b({
      staticClass: "input",
      attrs: {
        value: _vm.formatNumber(product.qtd),
        placeholder: "Informe a quantidade de caixas",
        type: "text",
        id: "uname",
        expanded: ""
      },
      on: {
        input: function input($event) {
          return _vm.changeProductInput("qtd", product._id, $event);
        }
      }
    }, "money", _vm.money_integer, false))], 1)], 1), _vm._v(" "), _c("b-field", {
      staticClass: "mt-8",
      attrs: {
        expanded: "",
        grouped: ""
      }
    }, [_c("b-field", {
      attrs: {
        label: "Valor por caixa (R$)",
        expanded: ""
      }
    }, [_c("money", _vm._b({
      staticClass: "input",
      attrs: {
        value: _vm.formatNumber(product.price),
        placeholder: "Informe o custo",
        prefix: "R$ ",
        type: "text",
        id: "uname",
        expanded: ""
      },
      on: {
        input: function input($event) {
          return _vm.changeProductInput("price", product._id, $event);
        }
      }
    }, "money", _vm.money, false))], 1), _vm._v(" "), _c("b-field", {
      attrs: {
        label: "Valor de Conversão (Opcional)",
        expanded: ""
      }
    }, [_c("money", _vm._b({
      staticClass: "input",
      attrs: {
        value: _vm.formatNumber(product.convertion),
        placeholder: "Informe o valor de conversão",
        type: "text",
        id: "uname",
        expanded: ""
      },
      on: {
        input: function input($event) {
          return _vm.changeProductInput("convertion", product._id, $event);
        }
      }
    }, "money", _vm.money_integer, false))], 1)], 1), _vm._v(" "), _c("b-field", {
      staticClass: "mt-8",
      attrs: {
        expanded: "",
        grouped: ""
      }
    }, [_c("SelectPlot", {
      attrs: {
        "default-selected": product.plotId,
        "default-selected-subplot": product.subPlotId
      },
      on: {
        onSelect: function onSelect($event) {
          return _vm.changeProductInput("plotId", product._id, $event);
        },
        onSelectSubplot: function onSelectSubplot($event) {
          return _vm.changeProductInput("subPlotId", product._id, $event);
        }
      }
    })], 1), _vm._v(" "), _c("b-field", {
      staticClass: "btn-field",
      attrs: {
        expanded: ""
      }
    }, [_c("b-button", {
      staticClass: "btn-outline",
      on: {
        click: function click($event) {
          return _vm.deleteProduct(product._id);
        }
      }
    }, [_vm._v("\n            Remover produto\n          ")])], 1)], 1)])], 1);
  })], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;